/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type RegularTransportMode = typeof RegularTransportMode[keyof typeof RegularTransportMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegularTransportMode = {
  RoundTrip: 'RoundTrip',
  OneWay: 'OneWay',
  Undetermined: 'Undetermined',
} as const;
